// import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import './SpecialOffersFilters.style';
import ExpandableContent from 'Component/ExpandableContent';
import ExpandableContentShowMore from 'Component/ExpandableContentShowMore';
import Field from "Component/Field";
import matchSearchString from "../../../../util/String/Helper";
import PropTypes from 'prop-types';

export class SpecialOffersFilters extends PureComponent {

    static propTypes = {
        categoryFilter : PropTypes.object.isRequired
    };

    state = {
        searchString: ''
    }

    renderAttribute(attribute){
        const { options, fieldLabel, fieldCode } = attribute;
        const { collapsTab, toggleExpandableContent } = this.props;
        const { searchString } = this.state;

        if (fieldCode === 'brands') {
            return (
                <ExpandableContent
                    key={fieldCode}
                    heading={ fieldLabel }
                    isContentExpanded={ !collapsTab.includes(fieldCode) }
                    onClick={ () => toggleExpandableContent(fieldCode) }
                    mix={ { block: 'SpecialOffersFilters' } }
                    mods={ { isWithoutBorder: true } }
                >
                    <Field nam='search' type='text' onChange={(value)=>this.setState({searchString: value})}></Field>
                    <ExpandableContentShowMore isCategoryFilter={ true } searchString={searchString}>
                        {options.map((option) => {
                            if(searchString && !matchSearchString(searchString,option.label) )
                                return null;
                            return (
                                this.renderOptions(option,fieldCode)
                            );
                        })}
                    </ExpandableContentShowMore>
                </ExpandableContent>
            );
        }

        return (
            <ExpandableContent
                key={fieldCode}
                heading={ fieldLabel }
                isContentExpanded={ !collapsTab.includes(fieldCode) }
                onClick={ () => toggleExpandableContent(fieldCode) }
                mix={ { block: 'SpecialOffersFilters' } }
                mods={ { isWithoutBorder: true } }
            >
                <ExpandableContentShowMore isCategoryFilter={ true }>
                    {
                        options.map((option)=> this.renderOptions(option,fieldCode))
                    }
                </ExpandableContentShowMore>
            </ExpandableContent>
        );
    }

    renderOptions(option,fieldCode){
        const { label, resultsCount, value } = option;
        const { customFilters : { [fieldCode] : filterOptionArray = [] }, filterOptionClick } = this.props;
        return (
            <div
                key={value}
                onClick={()=> filterOptionClick(String(value),fieldCode)}
            >
                <span className="SpecialOffersFilters-checkbox">
                    <input  name={label} type="checkbox" value={value}  className={filterOptionArray.includes(String(value)) ? 'checked': ''}/>
                    <label  for={label}>{label}</label>
                    <p className='count'>{ resultsCount }</p>
                </span>
            </div>
        );
    }

    resetFilterButton(){
        const { resetAllFilters, customFilters } = this.props;

        if(!Object.values(customFilters).some((i)=> i.length)) return null;

        return (
            <div onClick={resetAllFilters} className="SpecialOffersFilters-resetall">
                <p>{__('Reset all') }</p>
            </div>
        );
    }

    render() {
        const { categoryFilter : { items } } = this.props;
        return (
            <div block="SpecialOffersFilters">
                { this.resetFilterButton() }
                { items.map(this.renderAttribute.bind(this))}
            </div>
        );
    }
}

export default SpecialOffersFilters;
